<template>
  <main class="container">
    <LoadingSpinner v-if="loadingOptionsList || loading" />
    <div class="mb-5" v-if="!loadingOptionsList && !loading">
      <div class="" v-if="showEditButton">
        <router-link to="/agencies/me" class="btn btn-primary float-right">{{
          $t("lang.label.edit")
        }}</router-link>
      </div>
      <h1>Proposition Commerciale Oliverlist Agency</h1>
      <div class="mt-5">
        <div v-if="!isSignatureDateExpired">
          <p>Date : {{ today }}</p>
          <p>Validité : {{ daysLeft }} jours</p>
        </div>

        <div v-else class="alert alert-danger">
          {{ $t("lang.appointments.expiredcontract") }}
        </div>

        <AgencyContractDetail :model="model" v-if="model.user !== undefined"/>

        <br /><br />

        <h5>24.Résiliation :</h5>
        <p>
          Vous pouvez demander l’arrêt de la prospection commerciale pour votre
          compte à tout moment en nous informant par email à l’adresse
          agency@oliverlist.com. La prestation prendre fin à la fin du mois
          (facturable) en cours. À la fin de cette période, les rendez-vous
          futurs n’ayant pas encore été effectués seront considérés comme
          facturables.
        </p>

        <br /><br />

        <div v-if="!isUserLogin && !isSignatureDateExpired">
          <router-link class="btn btn-primary float-right" to="/login">
            {{ $t("lang.appointments.loginandvalidatetheproposal") }}
          </router-link>
        </div>
        <div v-else-if="showForm">
          <vue-form-generator
            ref="termsForm"
            :schema="schemaTerms"
            :model="termsModel"
            :options="formOptions"
          ></vue-form-generator>

          <br /><br />

          <h5>Méthode de paiement</h5>

          <p>
            Pour finaliser votre contrat, veuillez ajouter une méthode de
            paiement valide. Aucun frais ne vous seront facturés suite à
            l’enregistrement de votre méthode de paiement. Vous pouvez décider
            de retirer votre méthode de paiement à n’importe quel moment sur
            l’application.
          </p>

          <BillingProfile
            ref="billingProfileForm"
            :key="billingProfileKey"
            :showSaveButton="false"
          />
          <CreditCardForm ref="creditCardForm" :showSaveButton="false" />

          <button class="btn btn-primary float-right" @click="sendForm()">
            {{ $t("lang.appointments.validatemycontract") }}
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { clientsService } from "@/_services";
import BillingProfile from "@/components/Billing/BillingProfile.vue";
import CreditCardForm from "@/components/Billing/CreditCardForm.vue";
import AgencyContractDetail from "@/components/Agencies/AgencyContractDetail.vue";
import TargetsView from "@/components/Agencies/TargetsView.vue";

export default {
  props: {},
  components: {
    LoadingSpinner,
    BillingProfile,
    CreditCardForm,
    TargetsView,
    AgencyContractDetail
  },
  data() {
    var self = this;
    return {
      loading: true,
      clientHash: undefined,
      termsModel: { accept_terms: false },
      billingProfileKey: 0,
      model: {},
      schemaTerms: {
        fields: [
          {
            type: "checkbox",
            label:
              "En cochant cette case, j'accepte les conditions générales de l'agence Oliverlist mentionnées ci-dessus.",
            model: "accept_terms",
            featured: true,
            required: true,
            styleClasses: "col-md-6",
            validator(value, field, model) {
              if (!value) {
                return [self.$t("lang.label.required")];
              }
              return [];
            },
            // hint: "Please enter your full name",
            // help: "This is an other longer help text",
            // onChanged: function (model, newVal, oldVal, field) {
            //   console.log(
            //     `Model's name changed from ${oldVal} to ${newVal}. Model:`,
            //     model
            //   );
            // },
            // onValidated: function (model, errors, field) {
            //   if (errors.length > 0)
            //     console.warn("Validation error in Name field! Errors:", errors);
            // },
            // attributes: {
            //   "data-toggle": "collapse",
            //   title: "Some Tooltip Title",
            // },
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
    };
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      totalLoading: (state) => state.optionsList.totalLoading,
      loadingOptionsList: (state) => !state.optionsList.contractListLoaded,
      hierarchyoptions: (state) => state.optionsList.all["regions"].data,
      hierarchyoptionsSearch: (state) =>
        state.optionsList.all["categories_search_words"].data,
      hierarchyoptionsSearchFunction: (state) =>
        state.optionsList.all["categories_search_function"].data,
      hierarchyoptionsSearchLevel: (state) =>
        state.optionsList.all["categories_search_level"].data,
      hierarchyoptionsGoogleAll: (state) =>
        state.optionsList.all["categories_google_all"].data,
      hierarchyoptionsCountry: (state) =>
        state.optionsList.all["countries"].data,
    }),
    today: function () {
      let currentDate = new Date();
      var day = currentDate.getDate();
      var month = currentDate.getMonth() + 1;
      var year = currentDate.getFullYear();
      return day + "/" + month + "/" + year;
    },
    daysLeft: function () {
      let now = new Date().getTime();
      let expiration = new Date(
        this.model.client.signature_expiration_date
      ).getTime();
      let days = parseInt((expiration - now) / 1000 / 3600 / 24);
      return days;
    },
    isUserLogin: function () {
      return (
        this.currentUser !== undefined &&
        this.currentUser !== null &&
        (this.currentUser.role_id == 4
        || this.currentUser.role_id == 1) 
      );
    },
    isSignatureDateExpired() {
      return this.daysLeft <= 0;
    },
    showForm: function () {
      return this.isUserLogin && !this.isSignatureDateExpired;
    },
    showEditButton: function () {
      return false && this.isUserLogin;
    },
  },
  created() {
    this.clientHash = this.$route.query.qclh;
    this.getAllOptionsList();
    if (
      !this.isUserLogin &&
      (this.clientHash === undefined || this.clientHash === "")
    ) {
      this.$router.push("/login");
    }
    if (this.isUserLogin && this.currentUser.agency_signed == 1) {
      // this.$router.push("/settings-account");
    }
    this.getAgency();
  },

  methods: {
    ...mapActions("optionsList", {
      getAllOptionsList: "getAll",
    }),
    sendForm() {
      let billingProfileModel = this.$refs.billingProfileForm.getModel();
      // console.log(billingProfileModel);

      let creditCardModel = this.$refs.creditCardForm.getModel();
      // console.log(creditCardModel);

      this.$refs.termsForm.validate();

      if (
        !billingProfileModel ||
        !creditCardModel ||
        this.$refs.termsForm.errors.length > 0
      ) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.missingdata"),
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t("lang.button.ok"),
        });
        return false;
      }

      this.$refs.billingProfileForm.saveBillingProfile().then((result) => {
        this.billingProfileKey++;
      });

      this.$refs.creditCardForm.saveSepaPaymentMethod().then((result) => {
        // show message
      });
    },
    getAgency() {
      this.loading = true;
      if (this.isUserLogin) {
        clientsService.getAgency(0).then((response) => {
          this.setModel(response);
        });
      } else {
        clientsService.getProposalAgency(this.clientHash).then((response) => {
          this.setModel(response);
        });
      }
    },

    setModel(response) {
      this.model = response;

      if (this.model.targets !== undefined && this.model.targets !== null) {
        this.model.targets.forEach((target) => {
          // convert empty array into object
          if (Array.isArray(target.data.employees)) {
            target.data.employees = {};
          }
          if (
            target.data.categories_jobs === undefined ||
            Array.isArray(target.data.categories_jobs)
          ) {
            target.data.categories_jobs = {};
          }
        });
      }
      this.checkData();
      this.loading = false;
    },
    checkData() {
      if (this.model.client != null && this.model.user != null) {
        if (this.model.client.signed_on === null) {
          return true;
        }
      }

      if (this.isUserLogin) {
        //this.$router.push("/settings-account");
      } else {
        this.$router.push("/login");
      }
    },
  },
  watch: {},
};
</script>